/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { mapRouteToRelativePath } from "../../util/routing";

export const CART_ROUTE_NAME = "cart";
export const CART_ROUTE = mapRouteToRelativePath(CART_ROUTE_NAME);

export const CART_URL_PARAMS = {
  IDS: "ids",
  QTYS: "qtys",
  SIZES: "sizes",
  COLORS: "colors",
} as const;

export const CART_URL_PARAM_KEYS = Object.values(CART_URL_PARAMS);
